/* global axios */
import ApiClient from './ApiClient';

class AtecClientsAPI extends ApiClient {
  constructor() {
    super('atec_clients', { accountScoped: true });
  }

  search(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params).forEach(k => {
      if (params[k] !== undefined && params[k] !== null && params[k] !== '')
        query.append(k, params[k]);
    });
    const url = query.toString() ? `${this.url}?${query.toString()}` : this.url;
    if (typeof window !== 'undefined' && window.axios)
      return window.axios.get(url);
    return axios.get(url);
  }

  sync(clientData) {
    const body = { client: clientData };
    if (typeof window !== 'undefined' && window.axios)
      return window.axios.post(this.url, body);
    return axios.post(this.url, body);
  }
}

export default new AtecClientsAPI();
